var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMessageBox
    ? _c(
        "div",
        { staticClass: "referral-rewards-message-box-bg flex-center" },
        [
          _c("div", { staticClass: "referral-rewards-message-box" }, [
            _c("div", {
              staticClass: "referral-rewards-message-box-gradient-top",
            }),
            _c("div", {
              staticClass: "referral-rewards-message-box-gradient-bottom",
            }),
            !_vm.isfrom
              ? _c(
                  "div",
                  { staticClass: "referral-rewards-message-box-gradient-img" },
                  [_c("i", { staticClass: "icon icon-rewards-bg-img" })]
                )
              : _vm._e(),
            _c("div", { staticClass: "referral-rewards-message-box-top" }, [
              _c("i", {
                staticClass: "icon icon-close",
                on: { click: _vm.onShowMessageBox },
              }),
            ]),
            _c("div", { staticClass: "referral-rewards-message-box-main" }, [
              _c(
                "div",
                { staticClass: "referral-rewards-message-box-content" },
                [
                  !_vm.isfrom
                    ? [
                        _c("h3", [_vm._v("Get your referral link below")]),
                        _c("p", [_vm._v("Input your email address:")]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "referral-rewards-input margin-bottom-40 email-input flex-align-center",
                          },
                          [
                            _vm._m(0),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.from.email,
                                  expression: "from.email",
                                },
                              ],
                              attrs: { type: "text" },
                              domProps: { value: _vm.from.email },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.from,
                                    "email",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm.fromEmailsState === "error"
                              ? _c("span", { staticClass: "text-error" }, [
                                  _vm._v("* Please enter a valid email"),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c("p", [_vm._v("Your f(x)Core 0x wallet address:")]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "referral-rewards-input margin-bottom-40 address-input flex-align-center",
                          },
                          [
                            _vm._m(1),
                            _c("input", {
                              attrs: { type: "text", disabled: "" },
                              domProps: { value: _vm.getUser.address },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "box-but",
                            on: { click: _vm.toShareNow },
                          },
                          [
                            _c(
                              "ButtonCommon",
                              {
                                attrs: {
                                  type: "marginXBridge",
                                  width: "100%",
                                  disabled: _vm.isShareDisabled,
                                },
                              },
                              [
                                _c("strong", { staticClass: "text-download" }, [
                                  _vm._v("Submit"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c("div", { staticClass: "referral-link-box" }, [
                          _c("h3", [_vm._v("Your Referral Link")]),
                          _c("p", { staticClass: "text-opacity link-text" }, [
                            _vm._v(
                              " Please copy and share your personalised referral link as shown below. "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "referral-rewards-link-box" },
                            [_c("h6", [_vm._v(_vm._s(_vm.inviteUrl))])]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard:copy",
                                  value: _vm.inviteUrl,
                                  expression: "inviteUrl",
                                  arg: "copy",
                                },
                                {
                                  name: "clipboard",
                                  rawName: "v-clipboard:success",
                                  value: _vm.onCopy,
                                  expression: "onCopy",
                                  arg: "success",
                                },
                              ],
                              staticClass: "box-but",
                            },
                            [
                              _c(
                                "ButtonCommon",
                                {
                                  attrs: {
                                    type: "marginXBridge",
                                    width: "100%",
                                  },
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticClass: "text-download" },
                                    [_vm._v("Copy Link")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                ],
                2
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-icon emil flex-center" }, [
      _c("i", { staticClass: "icon icon-rewards-emil" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-icon addr flex-center" }, [
      _c("i", { staticClass: "icon icon-rewards-addr" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }